// Web storage that never throws: private windows, quotas and blocked-storage
// policies can throw on `window.localStorage` itself as well as on each method
// call. Every helper degrades to null / a no-op instead.

/** The storage of that kind, or null when the browser refuses access to it. */
export function safeStorage(kind: 'session' | 'local'): Storage | null {
  try {
    return kind === 'session' ? window.sessionStorage : window.localStorage;
  } catch {
    return null;
  }
}

/** The JSON stored under key, or null when absent, unreadable or not JSON. */
export function readJSON(storage: Storage | null, key: string): unknown {
  if (!storage) {
    return null;
  }

  try {
    const raw = storage.getItem(key);

    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function writeJSON(storage: Storage | null, key: string, value: unknown): void {
  try {
    storage?.setItem(key, JSON.stringify(value));
  } catch {
    // Quota or blocked storage — callers treat storage as best-effort.
  }
}

export function removeKey(storage: Storage | null, key: string): void {
  try {
    storage?.removeItem(key);
  } catch {
    // See writeJSON.
  }
}
